var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h2',[_vm._t("default")],2),(this.$slots['sub-title'])?_c('p',{staticClass:"page-sub-title"},[_vm._t("sub-title")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }